import { Button } from 'antd';
import type { ReactNode } from 'react';
import { useUserDetailModal } from './UserDetailModal';

interface UserLinkProps {
  /** 사용자 id. 없으면 클릭 불가 텍스트로 표시(폴백). */
  userId?: string | null;
  children: ReactNode;
}

/**
 * 클릭하면 사용자 상세 모달을 여는 링크형 사용자명.
 * userId 가 없으면 평문으로 렌더한다.
 */
export function UserLink({ userId, children }: UserLinkProps) {
  const { openUser } = useUserDetailModal();

  if (!userId) return <>{children}</>;

  return (
    <Button
      type="link"
      style={{ padding: 0, height: 'auto', fontWeight: 'inherit', textAlign: 'left' }}
      onClick={(e) => {
        e.stopPropagation();
        openUser(userId);
      }}
    >
      {children}
    </Button>
  );
}
